import React, { useState } from 'react';
import * as Routes from '@/modules/routes';
import I18n from 'i18n';
import Axios from 'axios';
import showToast from 'components/common/Toast';
import { LmsIconKind } from '@/components/shared/Lms/types';
import LmsButton from './LmsButton';
import Tooltip from '@/components/common/Tooltip';

interface SyncGradesProps {
  assignmentId: number;
  lmsKind: LmsIconKind | null;
}

const SyncGrades = ({ assignmentId, lmsKind }: SyncGradesProps) => {
  const [disabled, setDisabled] = useState<boolean>(false);
  const handleClick = () => {
    const url = Routes.plato_api_sync_grades_assignments_path();

    Axios.post(url, { ids: assignmentId.toString() })
      .then(() => {
        showToast('Grades are now syncing for this assignment');
        setDisabled(true);
      })
      .catch(() => {
      });
  };

  return (
    <Tooltip content={I18n.t('grade_sync_in_progress')} shouldDisplay={disabled}>
      <LmsButton
        disabled={disabled}
        handleClick={handleClick}
        lmsKind={lmsKind}
      >
        {I18n.t('sync_all_grades')}
      </LmsButton>
    </Tooltip>
  );
};

export default SyncGrades;
